function createMsgElement(element) {
    element = document.createElement("div");
    element.className = "adminMessage";
    document.body.prepend(element);
    return element;
}

/**
 * Show or hide admin message at the top of standard page. This function requires presence of #adminMessage element
 * in the DOM. If it is missing, nothing happens.
 * @param {string|string[]} adminMsg		message to the user (may be empty or null)
 */
export function showAdminMessage(adminMsg) {
    if (adminMsg) {
        let element = document.getElementById("adminMessage");
        if (!element) {
            element = createMsgElement(element);
            element.setAttribute("id", "adminMessage");
        }
		if (Array.isArray(adminMsg)) {
			// Multiple messages
			element.innerText = "";	/* Remove what's inside */
			for (let amsg of adminMsg) {
				const msgElm = document.createElement("div");
				msgElm.innerText = amsg;
				element.append(msgElm);
			}
		} else element.innerText = adminMsg;
    } else {
        let element = document.getElementById("adminMessage");
        if (element) {
            element.remove();
        }
    }
}
